import discoverTalent from '@assets/discover-talent.png';

import { EmptyStateCard } from '../EmptyStateCard/EmptyStateCard';

export const NoPositionsState: React.FC = () => (
  <EmptyStateCard
    image={discoverTalent}
    title="Discover best talent with AgileEngine"
    description="With 15+ global talent hubs, your time zone and budget are covered"
  />
);
